var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat;

var NewExpression = {
  print: function print(_ref) {
    var path = _ref.path,
        _print = _ref.print;
    return concat(['new ', path.call(_print, 'typeName')]);
  }
};
module.exports = NewExpression;